<template>
	<md-dialog
		:md-active.sync="dialog"
		:md-click-outside-to-close="false"
		:md-close-on-esc="false"
		@md-clicked-outside="close"
	>
		<md-card>
			<md-card-header>
				<div class="md-title">Motivo de rechazo</div>
			</md-card-header>

			<md-card-content>
				<form class="md-layout" id="payload_form" @submit.prevent="submit">
					<div class="md-layout-item md-size-100" v-if="!onlyFreeText">
						<md-field :class="validationClass('type')">
							<label>Tipo de rechazo</label>
							<md-select
								data-vv-name="type"
								v-validate="modelValidations.type"
								v-model="type"
							>
								<md-option
									v-for="type in rejectTypes"
									:value="type.id"
									:key="type.id"
								>
									{{ type.name }}
								</md-option>
							</md-select>
						</md-field>
					</div>

					<div class="md-layout-item md-size-100">
						<md-field :class="validationClass('reason')">
							<md-textarea
								data-vv-name="reason"
								v-validate="modelValidations.reason"
								v-model="reason"
								class="md-autogrow"
							>
							</md-textarea>
						</md-field>
					</div>

					<div class="md-layout-item md-size-50 md-small-size-100"></div>
				</form>
			</md-card-content>

			<md-card-actions>
				<md-button
					type="submit"
					form="payload_form"
					class="md-success md-dense md-simple"
					>Aceptar</md-button
				>
				<md-button class="md-danger md-dense md-simple" @click="close"
					>Cancelar</md-button
				>
			</md-card-actions>
		</md-card>
	</md-dialog>
</template>

<script>
import providesValidator from "@/mixins/providesValidator";

const modelValidations = {
	reason: {
		required: true,
	},
	type: {
		required: true,
	},
};
export default {
	name: "DialogPrompt",
	mixins: [providesValidator],
	props: {
		dialog: {
			type: Boolean,
			required: true,
			default: () => false,
		},
		rejectTypes: {
			type: Array,
			required: false,
			default: () => [],
		},
    onlyFreeText: {
      type: Boolean,
      required: false,
      default: false,
    },
	},
	data: () => ({
		active: false,
		modelValidations,
		reason: null,
		type: null,
	}),
	methods: {
		submit() {
			this.$validator.validateAll().then((isValid) => {
				if (!isValid) {
					this.$notify({
						message: "Llena todos los campos <strong>CORRECTAMENTE</strong>",
						icon: "close",
						horizontalAlign: "center",
						verticalAlign: "top",
						type: "danger",
					});
					return;
				}
				this.$emit("rejectFiles", this.reason, this.type);
			});
		},
		close() {
			this.$emit("close");
		},
	},
	watch: {
		dialog(newVal) {
			if (newVal) {
				this.reason = null;
				this.type = null;
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.md-card {
	margin: 0px;
	min-width: 500px;
}
</style>



// WEBPACK FOOTER //
// src/components/DialogReasonReject.vue